import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom'

// import Sale from "@pages/DataStatistics/Sale/index";
import Behavior from "@pages/DataStatistics/Behavior/index"; // 客户行为数据
import Cart from "@pages/Cart/index";
import Po from "@pages/Po/Index/index";
import Distributor from "@pages/DataStatistics/Distributor";//分销商提成

class DataStatisticsRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/dataStatistics/behavior" component={Behavior} />
                <Route path="/dataStatistics/cart" component={Cart} />

                <Route path="/dataStatistics/po" component={Po} />
                <Route path="/dataStatistics/distributor" component={Distributor} />

                <Route path="/*" render={(props) => <Redirect to="/dataStatistics/behavior" />} />
            </Switch>
        );
    }
}
export default DataStatisticsRouter;